import { render } from "./AutoCompleteChip.molecule.vue?vue&type=template&id=32e9a0db&scoped=true&bindings={\"options\":\"props\",\"optionKey\":\"props\",\"label\":\"props\",\"handleTagSelect\":\"setup\"}"
import script from "./AutoCompleteChip.molecule.vue?vue&type=script&lang=ts"
export * from "./AutoCompleteChip.molecule.vue?vue&type=script&lang=ts"

import "./AutoCompleteChip.molecule.vue?vue&type=style&index=0&id=32e9a0db&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-32e9a0db"

export default script